module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_4.53268e13.png";